import React, { useState, useContext } from 'react'
import { Context } from '../../../contexts/Context'
import { StandaloneSearchBox } from '@react-google-maps/api'
import Filter from './Filter'
import SortBy from './SortBy'
import CONFIG from '../../../config'
import { Button } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'

export default function Search () {
  const { getNearbyCenters, handlePoint, originAddress } = useContext(Context)
  const [search, setSearch] = useState() // handled by StandaloneSearchBox
  const [filtersState, setFiltersState] = useState(false)

  function getMobileOperatingSystem () {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return 'Windows Phone'
    }

    if (/android/i.test(userAgent)) {
      return 'Android'
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'iOS'
    }

    return 'unknown'
  }

  // Search place Autocomplete
  const onSBLoad = (ref) => {
    setSearch(ref)
  }
  const onPlacesChanged = () => {
    let results
    if (search) results = search.getPlaces() // Returns the query selected by the user
    let selectedPlace
    if (results && results.length > 0) {
      selectedPlace = { lat: results[0]?.geometry?.location?.lat(), lng: results[0]?.geometry?.location?.lng() }
      getNearbyCenters(selectedPlace)
      handlePoint(selectedPlace)
    }
  }

  const os = getMobileOperatingSystem()

  const clearSearch = () => {
    const element = document.getElementById('input')
    if (element) {
      element.value = ''
    }
  }

  return (
    <div
  // onClick={()=>handleResultComponent()}
      className='search-component'
    >
      <h2 className='search-title'>
        <span style={{ fontSize: '28px', color: 'black' }} className='material-symbols-outlined'> near_me </span>
        <span style={{ fontSize: '1.3rem', fontWeight: '900' }}>Find My </span>
        <img className='tricog-logo' src={CONFIG.tricog_logo} alt='Tricog' />
      </h2>
      <StandaloneSearchBox
        onLoad={onSBLoad}
        onPlacesChanged={onPlacesChanged}
      >
        <div className='input-box'>
          <div className='inputBox-btn'>
            {os === 'Android'
              ? (
                <span style={{ fontSize: '23px', color: 'black' }} className='material-symbols-outlined'> search </span>
                )
              : null}
            <input
              type='search'
          // onChange={()=>handleResultComponent()}
              id='input' placeholder='Search Location or Pincode' defaultValue={originAddress}
            />
            {os === 'iOS'
              ? <div
                  onClick={clearSearch} style={{ fontSize: '12px', fontWeight: '400', marginTop: '5px', lineHeight: '12px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '50%', color: '#fff', background: '#C0C0C0', width: '16px', height: '16px' }}
                >
                <span style={{ paddingLeft: '1px' }}>x</span>
                </div>
              : null}
          </div>
          <Button className='filterBtn' onClick={() => setFiltersState(!filtersState)} sx={{ p: 0, m: 0, widhth: '10px' }}>
            <MenuIcon sx={{ fontSize: '30px', p: '0px', m: 0 }} />
          </Button>
        </div>
      </StandaloneSearchBox>

      <div className={filtersState ? 'filters-component show-mob-component' : 'hide-mob-component filters-component'}>
        <Filter />
        <SortBy />
      </div>
    </div>
  )
}
